module.exports = __webpack_public_path__ + "static/media/right-sizing-existing-stores.0f72c938.png";